export const START_REQUEST = "START_REQUEST";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAIL = "REQUEST_FAIL";

export const START_DEFAULT_COUNTRY = "START_DEFAULT_COUNTRY";
export const DEFAULT_COUNTRY = "DEFAULT_COUNTRY";
